import { useLocation as getLocation } from '@reach/router';
import { useIntl } from 'gatsby-plugin-intl';
import queryString from 'query-string';

const useBrowserLocation = ({ defaultLocation, defaultIntl } = {}) => {
  const { pathname: pathName, search } = defaultLocation || getLocation();
  const intl = defaultIntl || useIntl();
  const baseUrl = (
    process.env.BASE_URL || 'https://www.giftofchoice.ca'
  ).replace(/\/$/, '');
  const homePage = `${baseUrl}/${intl.locale}/`;
  const currentPage = `${baseUrl}${pathName}`;
  const queryParams = queryString.parse(search || '');

  return {
    baseUrl,
    pathName,
    homePage,
    currentPage,
    queryParams,
  };
};

export default useBrowserLocation;
